var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9995 6.99951C13.9995 6.08026 13.8185 5.17001 13.4667 4.32073C13.1149 3.47145 12.5993 2.69977 11.9493 2.04976C11.2992 1.39975 10.5276 0.884138 9.6783 0.532355C8.82902 0.180572 7.91877 -0.000488281 6.99951 -0.000488281C6.08026 -0.000488281 5.17001 0.180572 4.32073 0.532355C3.47145 0.884138 2.69977 1.39975 2.04976 2.04976C1.39975 2.69977 0.884138 3.47145 0.532355 4.32073C0.180572 5.17001 -0.000488295 6.08026 -0.000488281 6.99951C-0.000488281 8.38651 0.408512 9.67651 1.10451 10.7645H1.09651L6.99951 19.9995L12.9025 10.7645H12.8955C13.6164 9.64109 13.9996 8.33433 13.9995 6.99951ZM6.99951 9.99951C6.20386 9.99951 5.4408 9.68344 4.87819 9.12083C4.31558 8.55822 3.99951 7.79516 3.99951 6.99951C3.99951 6.20386 4.31558 5.4408 4.87819 4.87819C5.4408 4.31558 6.20386 3.99951 6.99951 3.99951C7.79516 3.99951 8.55822 4.31558 9.12083 4.87819C9.68344 5.4408 9.99951 6.20386 9.99951 6.99951C9.99951 7.79516 9.68344 8.55822 9.12083 9.12083C8.55822 9.68344 7.79516 9.99951 6.99951 9.99951Z",
    fill: "#163873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.fc6bd2d773940fc29de5aeccf173dd23.svg";
export { ForwardRef as ReactComponent };